import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { get } from 'lodash';
import { useTracking } from 'react-tracking';

import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import { colors, fontSize } from '../../constants/styleConstants';
import { addMailTolIfNeed, addProtocolIfNeed, isValidHttpUrl } from '../../utils/common';
import usePrivacyAttributes from '../../utils/privacy';
import { TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';
import { trackEvent } from '../../utils/tracking';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    paddingBottom: 10,
  },
  icon: {
    width: 20,
    height: 20,
    border: `1px solid ${colors.darkText}`,
    borderRadius: 200,
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: 1.6,
    '& span': {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    '& svg': {
      fontSize: 13,
    },
  },
  text: {
    fontSize: fontSize.medium,
    paddingLeft: 12,
  },
  phoneNumber: {
    color: colors.grey2,
  },
  textHidden: {
    fontSize: fontSize.basic,
    paddingLeft: 12,
    opacity: 0.5,
    fontStyle: 'italic',
    margin: 0,
  },

  normal: {
    color: 'inherit',
    display: 'flex',
    '&:hover': {
      color: 'inherit',
    },
  },
  link: {
    color: colors.blueChip,
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
      color: colors.blueChip,
    },
  },
  textRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '& > div > a > p': {
      display: 'none',
    },
    '& > div:first-child': {
      '& >a > p': {
        display: 'flex !important',
      },
    },
  },
  textColumn: {
    display: 'flex',
    flexDirection: 'column',
    wordBreak: 'break-word',
    '& > div > a > p': {
      display: 'none',
    },
    '& > div:first-child': {
      '& >a > p': {
        display: 'flex !important',
      },
    },
  },
  contactDetail: {},
});

const iconsMap = {
  0: <PhoneIcon />,
  1: <MailIcon />,
  4: <LocationOnIcon />,
  3: <PublicIcon />,
  5: <PublicIcon />,
};

const IconWithText = ({ items, isProfileContact, hideInfo }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  const tracking = useTracking();

  const { canSee } = usePrivacyAttributes();

  const contactType = get(items, '[0].contactType.id');
  return (
    <div className={classes.root}>
      <div className={classes.icon}>{iconsMap[contactType]}</div>
      <div className={contactType === 0 ? classes.textRow : classes.textColumn}>
        {items.map((item, index) => {
          const { value, href, target } = item;
          const link =
            contactType === 1
              ? addMailTolIfNeed(href) || addMailTolIfNeed(value)
              : addProtocolIfNeed(href) || (isValidHttpUrl(value) && value);
          return (
            <div key={index} className={classes.contactDetail}>
              {/* {hideInfo && isProfileContact && (item?.contactType?.id === 0 || item?.contactType?.id === 1) ? ( */}
              {(isProfileContact && !canSee(item?.privacyAttributes)) || hideInfo ? (
                <p className={classes.textHidden}>{t(`${TP}.HIDDEN`)}</p>
              ) : (
                <a
                  href={link || undefined}
                  target={target || '_blank'}
                  rel="noopener noreferrer"
                  className={href || isValidHttpUrl(value) ? classes.link : classes.normal}
                  onClick={() =>
                    tracking.trackEvent(
                      trackEvent({
                        name: 'click_contact_link',
                        data: { 'Click URL': value?.replace(/[()]/g, ''), click_url_type: contactType },
                      }),
                    )
                  }
                >
                  <span className={cx(classes.text, { [classes.phoneNumber]: item?.contactTypeId === 0 })}>
                    {value?.replace(/[()]/g, '')}
                  </span>
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

IconWithText.propTypes = {
  items: PropTypes.array,
  hideInfo: PropTypes.bool,
  handleTracking: PropTypes.func,
};

export default IconWithText;
